export const CARD_DATA = [
  {
    heading: "Your Study Buddy",
    name: "Mr. Keyur Soni",

    details: {
      l1: "Personalized Counseling",
      l2: "Streamlined Applications",
      l3: "Comprehensive Visa Support",
    },
  },

  {
    heading: "Path to Germany",
    name: "Mr. Keyur Soni",

    details: {
      l1: "Language Proficiency Training",
      l2: "University Selection Assistance",
      l3: "Post-Arrival Guidance",
    },
  },

  {
    heading: "Seamless Transitions",
    name: "Mr. Keyur Soni",

    details: {
      l1: "Admission Planning",
      l2: "Visa & Housing Support",
      l3: "Pre-Departure Tips",
    },
  },

  {
    heading: "Study Simplified",
    name: "Mr. Keyur Soni",

    details: {
      l1: "One-on-One Guidance",
      l2: "Application Perfection",
      l3: "Cultural Integration",
    },
  },

  {
    heading: "Your Gateway to German Education",
    name: "Mr. Keyur Soni",

    details: {
      l1: "Course & University Matchmaking",
      l2: "Visa Made Easy",
      l3: "Life in Germany Assistance",
    },
  },

  {
    heading: "From Aspirations to Admissions",
    name: "Mr. Keyur Soni",

    details: {
      l1: "Goal-Oriented Planning",
      l2: "Smooth Onboarding Support",
      l3: "End-to-End Assistance",
    },
  },
];
